<template>
<div class="other_view">
        <NoLimit v-if="edit_doc_type == 'NOLIMIT'"></NoLimit>
        <NoLimitApply v-if="edit_doc_type == 'NOLIMITAPPLY'"></NoLimitApply>
        <NoLimitNoApply v-if="edit_doc_type == 'NOLIMITNOAPPLY'"></NoLimitNoApply>
        <DeleteFile v-if="edit_doc_type == 'DELETEFILE'"></DeleteFile>
        <PassWord v-if="edit_doc_type == 'PASSWORD'" @submit_password="
                password => {
                    this.$emit('submit_password', password);
                }
            "></PassWord>
        <ExpireFile v-if="edit_doc_type == 'EXPIREFILE'"></ExpireFile>
        <div class="sensitive_container" v-if="edit_doc_type == 'SENSITIVEBLOCKED'">
            <OtherHead :tipText="$t('敏感内容文档')"></OtherHead>
            <div id="sensitive_blocked_id"></div>
        </div>
        <Loading v-if="edit_doc_type == 'LOADING'"></Loading>
    </div>
</template>

<script lang="ts">
import NoLimit from './NoLimit.vue';
import NoLimitApply from './NoLimitApply.vue';
import NoLimitNoApply from './NoLimitNoApply.vue';
import DeleteFile from './DeleteFile.vue';
import PassWord from './PassWord.vue';
import ExpireFile from './ExpireFile.vue';
import Loading from '../Loading.vue';
import { mapState } from 'vuex';
import { TocaWikiSensitiveBlocked } from '@toca/toca-wiki-template';
import '@toca/toca-wiki-template/dist/style.css';
import OtherHead from './OtherHead.vue';


export default {
    name: 'other_view',
    components: {
        DeleteFile,
        NoLimit,
        NoLimitApply,
        NoLimitNoApply,
        PassWord,
        ExpireFile,
        Loading
    },
    data() {
        return {
            sensitiveBlockedInstance: null
        };
    },
    computed: {
        ...mapState({
            doc_id: state => state.kbModule.doc_id,
            doc_info: state => state.kbEditModule.doc_info,
            edit_doc_type: state => state.kbEditModule.edit_doc_type,
            wikiI18n: (state: any) => state.kbModule.wikiI18n,
            creator: (state: any) => state.sensitiveContentInfoModule.creator
        }),
        addLismit() {}
    },
    watch: {
        edit_doc_type: {
            immediate: true,
            handler(newVal: string) {
                if (newVal === 'SENSITIVEBLOCKED') {
                    setTimeout(() => {
                        let userName = this.doc_info?.fileInfo?.creatorInfo?.userName;
                        let employeeNo = this.doc_info?.fileInfo?.creatorInfo?.employeeNo;
                        if(userName && userName.length > 0 && employeeNo && employeeNo.length > 0){
                            userName = userName + '(' + employeeNo + ')';
                        }
                        this.sensitiveBlockedInstance = new TocaWikiSensitiveBlocked('#sensitive_blocked_id',{
                            locale: this.wikiI18n,
                            env: import.meta.env.MODE,
                            userName: this.creator || userName || '',
                        });
                    }, 500);
                }
            }
        }
    },
    methods: {}
};
</script>

<style lang="scss" scoped>
.other_view {
    display: flex;
    flex: 1;

    .sensitive_container {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    #sensitive_blocked_id {
        flex: 1;
    }
}
</style>
